let CordovaUtils = {}

CordovaUtils.setCustomBackHistory = function (fn) {
  if (typeof window !== 'undefined') {
    window.customBackHistory = fn
  }
}

/**
 * 浮层/全屏盖在页面上时使用：将物理/左侧返回先交给浮层，关闭时再用 clear 恢复进入浮层前的回调。
 * 避免直接 setCustomBackHistory 覆盖后无法还原上一页的 goBack。
 */
var _customBackBeforeOverlay = null
var _customBackOverlayActive = false
CordovaUtils.setCustomBackForOverlay = function (fn) {
  if (_customBackOverlayActive) {
    CordovaUtils.clearCustomBackForOverlay()
  }
  if (typeof window !== 'undefined' && window.customBackHistory) {
    _customBackBeforeOverlay = window.customBackHistory
  } else {
    _customBackBeforeOverlay = null
  }
  _customBackOverlayActive = true
  CordovaUtils.setCustomBackHistory(fn)
}
CordovaUtils.clearCustomBackForOverlay = function () {
  if (!_customBackOverlayActive) {
    return
  }
  _customBackOverlayActive = false
  var prev = _customBackBeforeOverlay
  _customBackBeforeOverlay = null
  CordovaUtils.setCustomBackHistory(prev)
}

export default CordovaUtils
